<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="pj_decode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_decode || "需求单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_decode }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_dename">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_dename }}
          </div>
        </div>
        <div class="weui-cell" slot="de_custname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_custname || "项目来源"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_custname }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_product_type">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_product_type || "产品类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_product_type }}
          </div>
        </div>
        <div class="weui-cell" slot="de_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_emname || "需求人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="de_dpname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_dpname }}
          </div>
        </div>
        <div
          class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after"
          slot="pj_project_classify"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_project_classify || "项目分类"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.pj_project_classify"
              placeholder="请选择"
            >
              <option value="销售立项">销售立项</option>
              <option value="产品立项">产品立项</option>
              <option value="技术立项">技术立项</option>
            </select>
          </div>
        </div>
        <div
          class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after"
          slot="pj_project_level"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_project_level || "项目等级"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.pj_project_level"
              placeholder="请选择"
            >
              <option value="高">高</option>
              <option value="中">中</option>
              <option value="低">低</option>
            </select>
          </div>
        </div>
        <employee-field
          :label="customLabel.pj_emname || '项目负责人'"
          v-model="form.main.pj_emname"
          @select="onSelectProEmployee"
          slot="pj_emname"
        />
        <date-field
          slot="pj_begin_date"
          :label="customLabel.pj_begin_date || '计划开始时间'"
          v-model="form.main.pj_begin_date"
        />
        <date-field
          slot="pj_end_date"
          :label="customLabel.pj_end_date || '计划结束时间'"
          v-model="form.main.pj_end_date"
        />
        <div class="weui-cell" slot="pj_budget">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_budget || "项目预算金额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.pj_budget"
              placeholder="请输入目标成本"
            />
          </div>
        </div>
        <div class="weui-cell" slot="pj_marcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_marcode || "市场分析报告"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_marcode }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_tarcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_tarcode || "技术可行性分析"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_tarcode }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_carcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_carcode || "成本分析报告"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_carcode }}
          </div>
        </div>
      </custom-layout>

      <div class="tab">
        <a :class="{ active: activity == 1 }" @click="setActivity(1)"
          >配置需求明细</a
        >
        <a :class="{ active: activity == 2 }" @click="setActivity(2)"
          >主要参数</a
        >
      </div>
      <collapse
        v-show="activity == 1"
        :title="'配置需求明细（' + form.items1?.length + '条）'"
      >
        <div
          class="weui-cells__group"
          v-for="(item, xindex) in form.items1"
          :key="'item1-' + xindex"
        >
          <div class="weui-cells__title">
            <span>配置需求{{ xindex + 1 }}</span>
          </div>
          <div class="weui-cells">
            <custom-layout :view-config="customViewConfig" position="detail1">
              <div class="weui-cell" slot="dd_name">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_name || "名称"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_name }}
                </div>
              </div>
              <div class="weui-cell" slot="dd_spec">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_spec || "规格"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_spec }}
                </div>
              </div>
              <div class="weui-cell" slot="dd_brand">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_brand || "品牌"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_brand }}
                </div>
              </div>
              <div class="weui-cell" slot="dd_colour">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_colour || "颜色"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_colour }}
                </div>
              </div>
              <div class="weui-cell" slot="dd_size">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_size || "尺寸"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_size }}
                </div>
              </div>
              <div class="weui-cell" slot="dd_texture">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_texture || "材质"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_texture }}
                </div>
              </div>
              <div class="weui-cell" slot="dd_silkscreen">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_silkscreen || "丝印"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_silkscreen }}
                </div>
              </div>
              <div class="weui-cell" slot="dd_standard">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_standard || "标准"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_standard }}
                </div>
              </div>
              <div class="weui-cell" slot="dd_remark">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.dd_remark || "备注"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  {{ item.dd_remark }}
                </div>
              </div>
              <custom-field
                :readOnly="true"
                :label="customLabel.dd_text1 || '自定义字段1'"
                v-model="form.main.dd_text1"
                slot="dd_text1"
                hidden="true"
              />
              <custom-field
                :readOnly="true"
                :label="customLabel.dd_text2 || '自定义字段2'"
                v-model="form.main.dd_text2"
                slot="dd_text2"
                hidden="true"
              />
              <custom-field
                :readOnly="true"
                :label="customLabel.dd_text3 || '自定义字段3'"
                v-model="form.main.dd_text3"
                slot="dd_text3"
                hidden="true"
              />
              <custom-field
                :readOnly="true"
                :label="customLabel.dd_text4 || '自定义字段4'"
                v-model="form.main.dd_text4"
                slot="dd_text4"
                hidden="true"
              />
              <custom-field
                :readOnly="true"
                :label="customLabel.dd_text5 || '自定义字段5'"
                v-model="form.main.dd_text5"
                slot="dd_text5"
                hidden="true"
              />
            </custom-layout>
          </div>
        </div>
      </collapse>
      <div v-show="activity == 2">
        <div
          class="weui-cells__group"
          v-for="(item, xindex) in form.items2"
          :key="'item2-' + xindex"
        >
          <div class="weui-cells__title">
            <span>主要参数{{ xindex + 1 }}</span>
            <a
              href="javascript:;"
              class="header-tool"
              @click="removeItem(xindex)"
            >
              <span>删除</span>
            </a>
          </div>
          <div class="weui-cells">
            <custom-layout :view-config="customViewConfig" position="detail2">
              <div class="weui-cell" slot="pp_name">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.pp_name || "参数名称"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  <input
                    class="weui-input"
                    type="text"
                    v-model="item.pp_name"
                    placeholder="请输入"
                  />
                </div>
              </div>
              <div class="weui-cell" slot="pp_value">
                <div class="weui-cell__hd">
                  <label for class="weui-label">{{
                    customLabel.pp_value || "参数值"
                  }}</label>
                </div>
                <div class="weui-cell__bd">
                  <input
                    class="weui-input"
                    type="text"
                    v-model="item.pp_value"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </custom-layout>
            <a
              href="javascript:"
              v-if="form.items2 && xindex == form.items2.length - 1"
              class="weui-cell weui-cell_link"
              @click="addItem"
            >
              <div class="weui-cell__bd">添加更多</div>
            </a>
          </div>
        </div>
      </div>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items3"
        :key="'item3-' + xindex"
      >
        <div class="weui-cells__title">
          <span>研发阶段{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem2(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail3">
            <combo-field
              slot="pp_name"
              :label="customLabel.pp_name || '研发阶段'"
              v-model="item.pp_name"
              url="/api/plm/research/getRpCombo"
              :params="{ productType: form.main.pj_product_type }"
            />
            <employee-field
              :label="customLabel.pp_emname || '阶段负责人'"
              v-model="item.pp_emname"
              @select="onSelectEmployee($event, item)"
              slot="pp_emname"
            />
            <div class="weui-cell" slot="pp_tel">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pp_tel || "联系电话"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.pp_tel }}
              </div>
            </div>
            <date-field
              slot="pp_begin_date"
              :label="customLabel.pp_begin_date || '开始日期'"
              v-model="item.pp_begin_date"
            />
            <date-field
              slot="pp_end_date"
              :label="customLabel.pp_end_date || '完成日期'"
              v-model="item.pp_end_date"
            />
          </custom-layout>
          <a
            href="javascript:"
            v-if="form.items3 && xindex == form.items3.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem2"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items4"
        :key="'item4-' + xindex"
      >
        <div class="weui-cells__title">
          <span>任务安排明细{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem3(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail4">
            <task-field
              slot="ta_task"
              :label="customLabel.ta_task || '研发任务'"
              :condition="con"
              :extraParams="{
                mode: 'DETAIL',
                size: 20,
              }"
              v-model="item.ta_task"
              @select="onSelectTask($event, item)"
            />
            <div class="weui-cell" slot="ta_rpname">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ta_rpname || "研发阶段"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.ta_rpname }}
              </div>
            </div>
            <div class="weui-cell" slot="ta_role">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ta_role || "岗位"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.ta_role }}
              </div>
            </div>
            <employee-field
              :label="customLabel.ta_emname || '任务责任人'"
              v-model="item.ta_emname"
              @select="onSelectEmp($event, item)"
              slot="ta_emname"
            />
            <div class="weui-cell" slot="ta_emtel">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ta_emtel || "联系电话"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.ta_emtel }}
              </div>
            </div>
            <div class="weui-cell" slot="ta_planworkhour">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ta_planworkhour || "计划工时"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.ta_planworkhour"
                  @change="onPlanWorkhourChange(item)"
                  placeholder="请输入工时"
                />
              </div>
            </div>
            <datetime-field
              slot="ta_planbegindate"
              :label="customLabel.ta_planbegindate || '开始日期'"
              v-model="item.ta_planbegindate"
              @selected="onPlanBeginDateChange(item)"
            />
            <div class="weui-cell" slot="ta_planenddate">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ta_planenddate || "完成日期"
                }}</label>
              </div>
              <div class="weui-cell__bd" v-format="'yyyy-MM-dd hh:mm'">
                {{ item.ta_planenddate }}
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="form.items4 && xindex == form.items4.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem3"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.de_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DatetimeField from "@/components/field/DatetimeField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import TaskField from "@/components/field/TaskField.vue";
import FileField from "@/components/field/FileField.vue";
import DateField from "@/components/field/DateField.vue";
import process from "@/mixins/process.js";
import Collapse from "@/components/Collapse.vue";
import ComboField from "@/components/field/ComboField.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    DatetimeField,
    EmployeeField,
    TaskField,
    DateField,
    FileField,
    Collapse,
    ComboField,
    CustomField,
  },
  mixins: [process],
  data() {
    return {
      activity: 1,
      baseUrl: "/api/plm/proj",
      codeField: "pj_code",
      statusField: "pj_statuscode",
      caller: "PlmProj",
      xtype: "plm-proj-formpanel",
      form: {
        main: {
          pj_deid: null,
          pj_decode: null,
          pj_dename: null,
          de_custname: null,
          pj_product_type: null,
          de_emname: null,
          de_dpname: null,
          pj_project_classify: null,
          pj_project_level: null,
          pj_emid: null,
          pj_emcode: null,
          pj_emname: null,
          pj_begin_date: null,
          pj_end_date: null,
        },
        items1: [],
        items2: [
          {
            pp_detno: null,
            pp_name: null,
            pp_value: null,
            dd_colour: null,
            dd_size: null,
            dd_texture: null,
            dd_silkscreen: null,
            dd_standard: null,
          },
        ],
        items3: [
          {
            pp_rpid: null,
            pp_detno: null,
            pp_name: null,
            pp_emid: null,
            pp_emcode: null,
            pp_emname: null,
            pp_tel: null,
          },
        ],
        items4: [
          {
            ta_rdid: null,
            ta_task: null,
            ta_rpname: null,
            ta_roleid: null,
            ta_role: null,
            ta_emid: null,
            ta_emcode: null,
            ta_dpid: null,
            ta_emname: null,
            ta_emtel: null,
            ta_planworkhour: null,
            ta_planbegindate: null,
            ta_planenddate: null,
          },
        ],
      },
      con: [
        {
          field: "rs_statuscode",
          operation: "=",
          value: "AUDITED",
        },
      ],
    };
  },
  created() {
    if (this.form.main.pj_product_type) {
      this.con.push({
        field: "rs_product_type",
        operation: "=",
        value: this.form.main.pj_product_type,
      });
    }
  },
  methods: {
    onCalc(obj) {
      let me = this,
        id = obj.ta_emid,
        startDate = obj.ta_planbegindate,
        hours = obj.ta_planworkhour;

      var params = {
        emid: id,
        start: startDate,
        hour: hours,
      };
      if (!hours || !startDate || !id) {
        return;
      }

      me.$loading({
        url: "/api/oa/vacation/getEndTimeByHour",
        params,
      }).then(function (res) {
        if (res.success) {
          if (res.data) {
            obj.ta_planenddate = res.data;
          }
        }else{
          obj.ta_planenddate = null;
          me.$weui.topTips(res.message, 2000);
        }
      });
    },

    /**
     * 监听计划工时变化
     */
    onPlanWorkhourChange(obj) {
      // 当计划工时变化时，重新计算完成时间
      this.onCalc(obj);
    },

    /**
     * 监听开始日期变化
     */
    onPlanBeginDateChange(obj) {
      // 当开始日期变化时，重新计算完成时间
      this.onCalc(obj);
    },
    setActivity: function (activity) {
      this.activity = activity;
      if (this.form.items2.length == 0) {
        this.form.items2.push({
          pp_detno: null,
          pp_name: null,
          pp_value: null,
          dd_colour: null,
          dd_size: null,
          dd_texture: null,
          dd_silkscreen: null,
          dd_standard: null,
        });
      }
    },
    onSelectProEmployee(selection) {
      let me = this,
        main = me.form.main;
      main.pj_emid = selection.id;
      main.pj_emcode = selection.em_code;
    },
    //选择项目负责人
    onSelectEmployee(selection, item) {
      item.pp_emid = selection.id;
      item.pp_emcode = selection.em_code;
      item.pp_tel = selection.em_mobile;
    },
    onSelectTask(selection, item) {
      item.ta_rdid = selection.rd_id;
      item.ta_rpname = selection.rd_process;
      item.ta_taskroute = selection.rd_taskroute;
      item.ta_task = selection.rd_task;
      item.ta_planworkhour = selection.rd_workhour;
      item.ta_role = selection.rd_role;
      item.ta_costprice = selection.rd_costprice;
      item.ta_roleid = selection.rd_roleid;
    },
    //选择任务负责人
    onSelectEmp(selection, item) {
      item.ta_emid = selection.id;
      item.ta_emcode = selection.em_code;
      item.ta_emtel = selection.em_mobile;
    },

    /**
     * 保存
     */
    save() {
      let me = this,
        main = me.form.main,
        items2 = me.form.items2,
        items3 = me.form.items3,
        items4 = me.form.items4;
      if (!main.pj_project_classify) {
        me.$weui.topTips("请选择项目分类", 2000);
      } else if (!main.pj_emname) {
        me.$weui.topTips("请选择项目负责人", 2000);
      } else if (!main.pj_project_level) {
        me.$weui.topTips("请选择项目等级", 2000);
      } else {
        var count2 = 0,
          count3 = 0,
          count4 = 0;
        items2.forEach(function (item) {
          count2++;
          item.pp_detno = count2;
        });
        items3.forEach(function (item) {
          count3++;
          item.pp_detno = count3;
        });
        items4.forEach(function (item) {
          count4++;
          item.ta_detno = count4;
        });
        me.p_save();
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items2 = me.form.items2;
      items2.push({
        pp_name: null,
        pp_value: null,
      });
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items2 = me.form.items2;
      if (items2.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items2.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem2() {
      var me = this,
        items3 = me.form.items3;
      items3.push({
        pp_name: null,
        pp_rpid: null,
        pp_emname: null,
        pp_emid: null,
        pp_emcode: null,
        pp_tel: null,
        pp_begin_date: null,
        pp_end_date: null,
      });
    },
    removeItem2(index) {
      var me = this,
        items3 = me.form.items3;
      if (items3.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items3.splice(index, 1);
      }
    },
    addItem3() {
      var me = this,
        items4 = me.form.items4;
      items4.push({
        ta_rdid: null,
        ta_task: null,
        ta_rpname: null,
        ta_roleid: null,
        ta_role: null,
        ta_emid: null,
        ta_emcode: null,
        ta_dpid: null,
        ta_emname: null,
        ta_emtel: null,
        ta_planworkhour: null,
        ta_planbegindate: null,
        ta_planenddate: null,
      });
    },
    removeItem3(index) {
      var me = this,
        items4 = me.form.items4;
      if (items4.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items4.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: #fff;
}
.tab > a {
  padding: 10px 20px;
}
.tab > .active {
  color: #1c8ef0;
}
</style>